import MoveFilesToCollectionForm from './MoveFilesToCollectionForm';

export default MoveFilesToCollectionForm;
